














































































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import Nav from "@/components/nav/navBar.vue";
import * as types from "@/store/constants/types";
import ScrollView from "@/components/scroll/flipScroll.vue";
import Tab from "@/components/tab/Tab.vue";
import { swiperSlide } from "vue-awesome-swiper";
import Swiper from "@/components/swiper/Swiper.vue";
import FreeCoins from "../freeCoins/FreeCoins.vue";
import VipBTabPage from "@/views/vipPlanB/VipBTabPage.vue";
import BakcPress from "@/utils/backPress";
import { CDN_BASE_URL } from "@/config/config";
import NumUtils from "@/utils/numUtils";
import { routerInclude } from "@/utils/routerStackUtil";
import VipButton from "@/views/vipPlanB/VipButton.vue";
import { sendEvent, sendEventWithParams } from "@/utils/analytics";
import GeneralUtils from "@/utils/generalUtils";
import LaunchUtils from "@/utils/launchUtils";

@Component({
  components: {
    Nav,
    ScrollView,
    Tab,
    Swiper,
    FreeCoins,
    swiperSlide,
    VipBTabPage,
    VipButton,
    VipPackages: () => import("@/components/coinEntrance/vipPackages.vue"),
    LuckyCoins: () => import("@/components/coinEntrance/luckyCoins.vue"),
    SkuSection: () => import("@/components/sku/skuSection.vue"),
    LimitedCoin: () => import("@/components/coinEntrance/limitedCoin.vue"),
    SuperpPayRecommend: () =>
      import("@/components/superPay/superPayRecommend/superPayRecommend.vue")
  }
})
export default class CoinsStoreContainer extends Vue {
  @Action(types.ROUTER_GO_BACK)
  private routerGoBack: any;
  @Action(types.ROUTER_REPLACE)
  private routerReplace: any;
  @Action(types.PAY_BY_ANY)
  private payByAny: any;
  @Action(types.ROUTER_PUSH)
  private routerPush: any;

  @Getter(types.GETTER_MASTER_COINS)
  private userCoins: any;
  @Getter(types.GETTER_CURRENT_INS_USER_INFO)
  private currentUserInfo: any;
  @Getter(types.GETTER_CASINO_ENABLED)
  private isCasinoEnabled!: boolean;
  @Getter(types.GETTER_SETTING_DATA)
  private settingData: any;
  @Getter(types.GETTER_LIMITED_COIN_SHOW)
  private limitedCoinsShow: any;

  private tabsArractiveIndex: number = 0;
  private specialStyle: any = {
    flex: 0.6,
    index: 2
  };

  get tabsArr() {
    const tabs = [
      {
        label: "Buy Coins",
        labelColor: "#5C75EC",
        acitveColor: "#5C75EC",
        imgUrl: CDN_BASE_URL.img + "/vip/store_buy_nav_icon.png"
      },
      {
        label: "Free Coins",
        labelColor: "#17C396",
        acitveColor: "#17C396",
        imgUrl: CDN_BASE_URL.img + "/tab/freecoins.png"
      },
      {
        label: "VIP",
        labelColor: "#ff6f00",
        acitveColor: "#ff6f00",
        imgUrl: CDN_BASE_URL.img + "/vip/store_vip_nav_icon.png"
      }
    ];
    return tabs;
  }

  get vipIsPlanB() {
    return LaunchUtils.isVipPlanB();
  }

  get superPayRecommendShow() {
    return !this.limitedCoinsShow;
  }

  get isVIP() {
    return GeneralUtils.isVip();
  }

  get leftIcon() {
    return this.isCasinoEnabled ? "casino" : "";
  }

  get format() {
    return NumUtils.format;
  }

  get coins() {
    return this.format(this.userCoins);
  }

  get vipOffer() {
    if (this.settingData == null || this.settingData === undefined) {
      return null;
    } else {
      const vipOffers = this.settingData.service_offers.filter((offer: any) => {
        return offer.kind === "vip";
      });
      return vipOffers.find((item: any) => {
        return item.effect === 1;
      });
    }
  }

  private slideChange(index: any) {
    this.tabsArractiveIndex = index;

    //video replay:
    // if (index === 0) {
    //   this.$refs.superPayRecommend
    //     ? (this.$refs.superPayRecommend as any).replayVideo()
    //     : void 0;
    // }
  }

  private clickClose() {
    BakcPress.destroy(this.$route.name as any);
    this.routerGoBackLogic();
  }

  private routerGoBackLogic() {
    let pathBackNum: number = 1;
    if (routerInclude("DoubleCoinSplash")) {
      //如果包含了double coins界面
      pathBackNum += 1;
    }
    if (routerInclude("HalfCoinsSplash")) {
      //如果包含了HalfCoinsSplash界面
      pathBackNum += 1;
    }
    this.routerGoBack(-pathBackNum);
  }

  private cliclVipButton() {
    // // test
    // this.routerPush({
    //   name: 'OrderDetail',
    //   params: {
    //     routerTransition: "up"
    //   }
    // });
    // return;
    // //

    this.payByAny({
      offer: this.vipOffer
    });
    sendEvent("uia_vip_1mo_click", "vip_tab");
    sendEventWithParams("uia_vip_other_click", { place: "tab4" });
    LaunchUtils.setBuyVipFrom("tab4");
  }

  private goCasino() {
    this.$router.push({
      name: "Casino",
      params: {
        routerTransition: "forward"
      }
    });
  }

  private mounted() {
    BakcPress.listen({
      key: this.$route.name,
      fn: () => {
        this.clickClose();
      }
    });
  }

  @Watch("tabsArractiveIndex", { immediate: false })
  private changeCurrentRoute() {
    this.routerReplace({
      name: "CoinsContainer",
      query: {
        tabIndex: this.tabsArractiveIndex
      }
    });
  }

  private activated() {
    const freecoin: any = this.$route.query.freecoin;
    if (freecoin) {
      this.tabsArractiveIndex = 1;
    }
  }
}
